import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import styled from 'styled-components';
import AdeAccordion from './AdeAccordion';
import { noDesktop, useIsMobile } from '../../style/constants';

function AccordionContent() {
  const { t } = useTranslation('home');
  const isMobile = useIsMobile();
  return (
    <Container className="w-100">
      <div className="d-flex flex-column align-items-center">
        <Title className={`text-center mb-3  ${isMobile ? 'mt-3' : ''}`}>
          {t('home:frequentlyAsked') as string}
        </Title>
      </div>
      <div className="rounded mb-2">
        {index.map(({ title, content, key }) => (
          <AdeAccordion
            key={key}
            title={t(title) as string}
            content={t(content) as string}
          />
        ))}
      </div>
    </Container>
  );
}

export default AccordionContent;

const Title = styled.h2`
  font-size: 36px !important;
  font-weight: 700;
  margin-bottom: 3rem;
  @media ${noDesktop} {
    font-size: 28px !important;
    margin-bottom: 2rem;
  }
`;

const Container = styled.div`
  padding-top: 3rem;
  @media ${noDesktop} {
    padding-top: 0;
  }
`;

const index = [
  {
    key: 1,
    title: 'contests:accordion.questionOne',
    content: `contests:accordion.answerOne`,
  },
  {
    key: 2,
    title: 'contests:accordion.questionTwo',
    content: `contests:accordion.answerTwo`,
  },
  {
    key: 3,
    title: 'contests:accordion.questionThree',
    content: `contests:accordion.answerThree`,
  },
  {
    key: 4,
    title: 'contests:accordion.questionFour',
    content: `contests:accordion.answerFour`,
  },
  {
    key: 5,
    title: 'contests:accordion.questionFive',
    content: `contests:accordion.answerFive`,
  },
  {
    key: 6,
    title: 'contests:accordion.questionSix',
    content: `contests:accordion.answerSix`,
  },
  {
    key: 7,
    title: 'contests:accordion.questionSeven',
    content: `contests:accordion.answerSeven`,
  },
  {
    key: 8,
    title: 'contests:accordion.questionEight',
    content: `contests:accordion.answerEight`,
  },
  {
    key: 9,
    title: 'contests:accordion.questionNine',
    content: `contests:accordion.answerNine`,
  },
];
